import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

const styles = {
  content: {
    maxHeight: '50vh',
    textAlign: 'justify',
    color: 'black',
  },
  title: {
    fontWeight: 'bold',
    color: 'black', 
  }
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const InfoPopUp = (props) => (
  <Dialog
    open={props.openDialog}
    onClose={props.changeDialogState}
    TransitionComponent={Transition}
    keepMounted
    aria-labelledby="info-dialog-title"
    aria-describedby="info-dialog-description"
    style={styles}
  >
    <DialogTitle disableTypography={true} id="info-dialog-title">
      <h1 style={{ color: 'black' }}>Welcome to the PACS Sizing Calculator!</h1>
    </DialogTitle>
    <DialogContent className={props.classes.content}>
      <DialogContentText id="info-dialog-description" style={{ color: 'black' }}>
        Our powerful tool takes the guesswork out of PACS planning by helping you pinpoint the optimal storage capacity for your Picture Archiving and Communication System (PACS). Avoid the costly pitfalls of over- or under-provisioning.
        All too often, PACS users and administrators invest in systems that are either oversized or undersized, which leads to slow performance and frustration. Our solution ensures you get the storage you need for your image data – maximizing efficiency, performance and return on investment.
        <br/><br/>
        <strong>Size your PACS with confidence!</strong>
        <br/><br/>
        At iQ IMAGE, we have developed the PACS Sizing Calculator – a smart, data-driven tool that helps you to determine the ideal size for your PACS. Whether you're planning a new installation or optimizing an existing setup, this tool provides a comprehensive overview of your system requirements, including:
        <ul>
          <li>Short-term data insights: Instantly estimate the number of studies and required disk space for DICOM data on a daily, monthly and yearly basis.</li>
          <li>Long-term projections: Plan with confidence using estimates for total archive storage, including DICOM files and database size, throughout the entire archive lifecycle.</li>
        </ul>
        <br/>
        The tool bases its calculations on key variables, such as:
        <ul>
          <li>Type of imaging center</li>
          <li>Geographical region</li>
          <li>Archive retention period</li>
          <li>Modalities in use (e.g. number of studies per day and images per study)</li>
        </ul>
        You don’t need to have every detail to hand. Any missing fields are automatically filled in using our extensive statistical database. This enables you to generate a complete, customized PACS sizing report, even when working with limited customer data.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={props.changeDialogState} variant="raised" color="primary">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

InfoPopUp.propTypes = {
  classes: PropTypes.object.isRequired,
  openDialog: PropTypes.bool.isRequired,
  changeDialogState: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(InfoPopUp);



// WEBPACK FOOTER //
// ./src/InfoPopUp.js